import React from 'react';
import Icons from './Icons';

const FooterSection = ({ isDark }) => (
  <footer className={`py-8 sm:py-12 md:py-16 transition-colors duration-300 ${isDark ? 'bg-[#0a0a0a]' : 'bg-gray-100'}`}>
    <div className="container-custom px-3 sm:px-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10 md:gap-12">
        {/* Brand Section */}
        <div className="sm:col-span-2 lg:col-span-1">
          <div className="flex items-center gap-3 sm:gap-4 mb-4 sm:mb-6">
            <img 
              src="/logo.jpg" 
              alt="Brothers Rental Logo" 
              className="w-14 h-14 sm:w-16 sm:h-16 md:w-20 md:h-20 rounded-xl object-cover shadow-lg"
            />
            <div>
              <span className={`font-bold text-lg sm:text-xl ${isDark ? 'text-white' : 'text-gray-900'}`}>Brothers</span>
              <span className="text-[#c9a962] font-bold text-lg sm:text-xl">Rental</span>
            </div>
          </div>
          <p className={`mb-4 sm:mb-6 text-sm sm:text-base ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Udaipur's premier luxury car rental service. Experience the city of lakes in ultimate comfort and style.</p>
          <div className="flex gap-3 sm:gap-4">
            <a href="https://www.facebook.com/share/1NDAhX4RoE/" target="_blank" rel="noopener noreferrer" className={`p-2 sm:p-2.5 rounded-full transition-colors ${isDark ? 'bg-gray-800 text-gray-400 hover:text-white' : 'bg-gray-200 text-gray-600 hover:text-[#c9a962]'}`}>
              <Icons.Facebook />
            </a>
            <a href="https://www.instagram.com/brothers_rental_udaipur/" target="_blank" rel="noopener noreferrer" className={`p-2 sm:p-2.5 rounded-full transition-colors ${isDark ? 'bg-gray-800 text-gray-400 hover:text-white' : 'bg-gray-200 text-gray-600 hover:text-[#E1306C]'}`}>
              <Icons.Instagram />
            </a>
            <a href="https://wa.me/919602360369" target="_blank" rel="noopener noreferrer" className={`p-2 sm:p-2.5 rounded-full transition-colors ${isDark ? 'bg-gray-800 text-gray-400 hover:text-white' : 'bg-gray-200 text-gray-600 hover:text-[#25D366]'}`}>
              <Icons.WhatsApp />
            </a>
          </div>
        </div>
        
        {/* Quick Links */}
        <div>
          <h4 className={`font-bold mb-4 sm:mb-6 text-base sm:text-lg ${isDark ? 'text-white' : 'text-gray-900'}`}>Quick Links</h4>
          <ul className={`space-y-2 sm:space-y-3 md:space-y-4`}>
            <li><a href="/" className={`text-sm sm:text-base hover:text-[#c9a962] transition-colors ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Home</a></li>
            <li><a href="/luxury-cars" className={`text-sm sm:text-base hover:text-[#c9a962] transition-colors ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Luxury Cars</a></li>
            <li><a href="/about" className={`text-sm sm:text-base hover:text-[#c9a962] transition-colors ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>About Us</a></li>
            <li><a href="/services" className={`text-sm sm:text-base hover:text-[#c9a962] transition-colors ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Services</a></li>
            <li><a href="/faq" className={`text-sm sm:text-base hover:text-[#c9a962] transition-colors ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>FAQ</a></li>
            <li><a href="/contact" className={`text-sm sm:text-base hover:text-[#c9a962] transition-colors ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Contact</a></li>
          </ul>
        </div>
        
        {/* Contact Us */}
        <div>
          <h4 className={`font-bold mb-4 sm:mb-6 text-base sm:text-lg ${isDark ? 'text-white' : 'text-gray-900'}`}>Contact Us</h4>
          <ul className={`space-y-3 sm:space-y-4`}>
            <li className="flex items-center gap-2 sm:gap-3">
              <span className={`w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-gradient-to-br from-[#c9a962] to-[#a08040] flex items-center justify-center text-black shadow-lg flex-shrink-0`}><Icons.MapMarker /></span>
              <a 
                href="https://www.google.com/maps/place/Brothers+Rental/@24.6010762,73.728059,17z" 
                target="_blank" 
                rel="noopener noreferrer"
                className={`text-sm sm:text-base hover:text-[#c9a962] transition-colors ${isDark ? 'text-gray-300' : 'text-gray-800'}`}
              >
                Udaipur, Rajasthan, India
              </a>
            </li>
            <li className="flex items-center gap-2 sm:gap-3">
              <span className={`w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-gradient-to-br from-[#c9a962] to-[#a08040] flex items-center justify-center text-black shadow-lg flex-shrink-0`}><Icons.Phone /></span>
              <a href="tel:9602360369" className={`text-sm sm:text-base hover:text-[#c9a962] transition-colors ${isDark ? 'text-gray-300' : 'text-gray-800'}`}>96023 60369</a>
            </li>
            <li className="flex items-center gap-2 sm:gap-3">
              <span className={`w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-gradient-to-br from-[#c9a962] to-[#a08040] flex items-center justify-center text-black shadow-lg flex-shrink-0`}><Icons.Mail /></span>
              <a href="mailto:brotherscarrental8286@gmail.com" className={`text-xs sm:text-sm hover:text-[#c9a962] transition-colors break-all ${isDark ? 'text-gray-300' : 'text-gray-800'}`}>brotherscarrental8286@gmail.com</a>
            </li>
            <li className="flex items-center gap-2 sm:gap-3">
              <span className={`w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-gradient-to-br from-[#c9a962] to-[#a08040] flex items-center justify-center text-black shadow-lg flex-shrink-0`}><Icons.Clock /></span>
              <span className={`text-sm sm:text-base ${isDark ? 'text-gray-300' : 'text-gray-800'}`}>24/7 Available</span>
            </li>
          </ul>
        </div>
        
        {/* Map Section */}
        <div className="sm:col-span-2 lg:col-span-1">
          <h4 className={`font-bold mb-4 sm:mb-6 text-base sm:text-lg ${isDark ? 'text-white' : 'text-gray-900'}`}>Our Location</h4>
          <div className={`relative rounded-xl sm:rounded-2xl overflow-hidden shadow-2xl group ${isDark ? 'bg-[#1a1a1a]' : 'bg-white'}`}>
            <div className="relative overflow-hidden">
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3627.6556892554504!2d73.72805897494952!3d24.601076155588437!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3967e5005edc66f1%3A0x1ce34447c597f4b4!2sBrothers%20Rental!5e0!3m2!1sen!2sin!4v1770899611176!5m2!1sen!2sin"
                width="100%"
                height="150"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Brothers Rental Location"
                className="transition-transform duration-500 group-hover:scale-110"
              ></iframe>
              <div className="absolute inset-0 bg-gradient-to-t from-[#c9a962]/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"></div>
            </div>
            <div className={`absolute bottom-2 sm:bottom-4 left-2 sm:left-4 px-2 sm:px-4 py-1 sm:py-2 rounded-full shadow-lg ${isDark ? 'bg-[#1a1a1a]' : 'bg-white'} flex items-center gap-1.5 sm:gap-2`}>
              <div className="w-2 h-2 sm:w-3 sm:h-3 bg-[#c9a962] rounded-full animate-pulse"></div>
              <span className={`text-xs sm:text-sm font-semibold ${isDark ? 'text-white' : 'text-gray-900'}`}>Udaipur, India</span>
            </div>
            <a 
              href="https://www.google.com/maps/place/Brothers+Rental/@24.6010762,73.728059,17z"
              target="_blank"
              rel="noopener noreferrer"
              className="absolute top-2 sm:top-4 right-2 sm:right-4 px-2 sm:px-4 py-1 sm:py-2 bg-[#c9a962] text-black text-xs sm:text-sm font-semibold rounded-full shadow-lg transform translate-y-[-50%] opacity-0 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300 hover:scale-105"
            >
              View Map
            </a>
          </div>
        </div>
      </div>
      
      {/* Copyright */}
      <div className={`border-t mt-8 sm:mt-12 pt-6 sm:pt-8 text-center ${isDark ? 'border-gray-800' : 'border-gray-300'}`}>
        <p className="text-xs sm:text-sm">
          <span className="text-[#c9a962] font-medium">© 2026 Brothers Car Rental.</span>
          <span className={`${isDark ? 'text-gray-500' : 'text-gray-500'}`}> All rights reserved.</span>
        </p>
        <p className={`text-xs sm:text-sm mt-2 ${isDark ? 'text-gray-500' : 'text-gray-500'}`}>
          Developed by{' '}
          <a 
            href="https://www.instagram.com/kingdigital.ai/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-[#c9a962] hover:text-[#a08040] transition-colors font-medium"
          >
            King Digital AI Technology Agency
          </a>
        </p>
      </div>
    </div>
  </footer>
);

export default FooterSection;
